module.exports = __webpack_public_path__ + "static/media/bimbo-logo.05a68c1d.png";